import React from "react";
import {
  SMS_MESSAGING_TERMS_URL,
  SMS_OPT_IN_BRAND_NAME,
  SMS_PRIVACY_POLICY_URL,
} from "../shared/utils/smsOptIn";

/**
 * Optional SMS / text messaging opt-in checkbox with Twilio-required disclosures
 * visible next to the control (unchecked by default).
 */
export default function SmsOptInConsentBlock({
  checked = false,
  onChange,
  checkboxId = "sms-opt-in-consent",
  disabled = false,
  className = "",
  termsUrl = SMS_MESSAGING_TERMS_URL,
  privacyUrl = SMS_PRIVACY_POLICY_URL,
  brandName = SMS_OPT_IN_BRAND_NAME,
}) {
  const rootClass = ["sms-opt-in-consent", className].filter(Boolean).join(" ");
  return (
    <div className={rootClass}>
      <label className="sms-opt-in-consent__checkbox" htmlFor={checkboxId}>
        <input
          id={checkboxId}
          type="checkbox"
          checked={!!checked}
          disabled={disabled}
          onChange={(e) => onChange && onChange(e.target.checked)}
        />
        <span>
          I agree to receive text messages from {brandName} about programs, events, registration
          confirmations, reminders, and schedule changes. Message frequency varies. Message and data
          rates may apply. Reply STOP to unsubscribe. Reply HELP for help.{" "}
          <a href={termsUrl} target="_blank" rel="noopener noreferrer">
            SMS Terms
          </a>
          {" · "}
          <a href={privacyUrl} target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
        </span>
      </label>
    </div>
  );
}
